import { IconProps } from "../types/icon";

export const RomanticRestaurantIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="M11.35 3.794 8 7.143l-3.349-3.35A2.219 2.219 0 1 1 8.001.9a2.219 2.219 0 1 1 3.348 2.894M6 11H2V6H0v10h2v-3h3v3h2v-4a1 1 0 0 0-1-1M14 6v5h-4a1 1 0 0 0-1 1v4h2v-3h3v3h2V6z"/>
        <path d="M11 10H5a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2"/>
      </g>
    </svg>
  );
};
